export default __webpack_public_path__ + "static/media/PerfNo2Closed.3c353a30.jpg";